import { Grid } from '@freighthub/silhouette-core'
import { FC, PropsWithChildren } from 'react'

export const QrRow: FC<PropsWithChildren> = (props) => (
  <Grid
    container
    spacing={2}
    wrap="nowrap"
    style={{
      marginBottom: '8px',
    }}
    {...props}
  />
)
export const QrCellLeft: FC<PropsWithChildren> = (props) => <Grid xs={2}>{props.children}</Grid>

export const QrCellXs: FC<PropsWithChildren> = (props) => <Grid xs>{props.children}</Grid>

export const QrCellCheckboxesInner: FC<PropsWithChildren> = (props) => (
  <div
    style={{
      marginTop: '-12px',
    }}
  >
    {props.children}
  </div>
)
